module.exports = __webpack_public_path__ + "img/saba_safsal_yes.0f82dcf1.png";